import('./pb-productgroupdetails-v2.css')

const pbProductGroupDetailsV2 = {
    init: function(){

        Util.service("WSPortobelloSite", true, {
            exceptionHandler: console.error,
            reflectSuccess: pbSiteService => {         

                $('body').off('click','ul.pb-downloads--buttons a.revit, ul.pb-downloads--buttons a.sketchup').on('click','ul.pb-downloads--buttons a.revit, ul.pb-downloads--buttons a.sketchup', function(e) {
                    var url = $(this).attr('href');
                    var type = $(this).hasClass('sketchup')?'sketchup':'revit';
                    var idProduct = $(this).data('idproduct');
                    var logData = {
                        //idYapoli:  idYapoli,
                        url: url,
                        type: type,
                        idProduct: idProduct
                    };
                    pbSiteService.insertDamImagesLogDownload(logData);
                });
            },
            reflectError: function() {
                console.error("Erro de conexão, verifique sua conexão com a internet.");
            },
        });
        // https://portobello.kanbanize.com/ctrl_board/103/cards/16903/details/
        $('.pb-productgroupdetails-v2 .pb-modal--downloads a').on('click', function(e)
        {
            var linkTitle = $(this).text().trim();
            var linkUrl = $(this).attr('href');
            window.dataLayer.push({
                'event': 'products_links',
                'file_name': linkTitle,
                'click_url':linkUrl
            });
        });
    }
   
}
        
// initialize component
window.loadedComponents.push({ component: 'pb-productgroupdetails-v2', init: pbProductGroupDetailsV2.init});

export default() => {
    pbProductGroupDetailsV2.init();
}